import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { StepTitle, OField, inputCls, NavButtons } from "@/components/onboard/ui";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { DeviceMobile, Info } from "@phosphor-icons/react";
import { toast } from "sonner";

export function StepPhone({ token, state, onSaved, onBack }) {
  const c = state.wizard.contact || {};
  const [phone, setPhone] = useState(c.phone || state.phone || "");
  const [email, setEmail] = useState(c.email || state.email || "");
  const [sent, setSent] = useState(false);
  const [devCode, setDevCode] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const send = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/onboard/${token}/sms/send`, { phone, email });
      setSent(true); setDevCode(data.dev_code || ""); toast.success("Verification code sent to your phone");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  const verify = async () => {
    setLoading(true);
    try { const { data } = await api.post(`/onboard/${token}/sms/verify`, { code }); toast.success("Phone verified"); onSaved(data); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); setCode(""); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <StepTitle kicker="Step 2 · Secure Your Account" title="Verify Your Phone" sub="We'll text a one-time code to your mobile number. Your email and phone become your login for the Asterism Carrier App." />
      {!sent ? (
        <div className="grid sm:grid-cols-2 gap-4 max-w-2xl">
          <OField label="Mobile Number *"><input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="(555) 123-4567" className={inputCls} data-testid="ob-phone" /></OField>
          <OField label="Email *"><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" className={inputCls} data-testid="ob-email" /></OField>
        </div>
      ) : (
        <div className="max-w-md">
          <div className="flex items-center gap-3 mb-5 text-white/70"><DeviceMobile size={26} className="text-sky-300" />Enter the 6-digit code sent to <b className="text-white">{phone}</b></div>
          <InputOTP maxLength={6} value={code} onChange={(v) => setCode(v.replace(/\D/g, ""))} autoFocus data-testid="ob-sms-input">
            <InputOTPGroup className="gap-2">{[0, 1, 2, 3, 4, 5].map((i) => <InputOTPSlot key={i} index={i} className="h-14 w-12 text-xl font-mono font-bold rounded-xl border border-white/15 bg-white/5 text-white" />)}</InputOTPGroup>
          </InputOTP>
          {devCode && (
            <p className="mt-4 text-xs text-amber-200 bg-amber-400/10 border border-amber-400/20 rounded-xl px-3 py-2 flex items-center gap-2" data-testid="ob-dev-code">
              <Info size={14} />Test mode: SMS is not connected yet. Your code is <b className="font-mono tracking-widest">{devCode}</b>
            </p>
          )}
          <button onClick={() => { setSent(false); setCode(""); }} className="mt-4 text-sm text-sky-300" data-testid="ob-change-phone">Change number / resend</button>
        </div>
      )}
      <NavButtons onBack={onBack} onNext={sent ? verify : send} loading={loading} disabled={sent ? code.length !== 6 : !phone || !email} nextLabel={sent ? "Verify Code" : "Send Code"} testid={sent ? "ob-verify-btn" : "ob-send-btn"} />
    </div>
  );
}
